/**
 * Dimensions of components used in JV and QV
 */
export const LOCATION_LIST_CONTAINER_WIDTH = 360;
export const DATA_TABS_HEIGHT = 70;
